import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
  PERMISSION_PRODUCTIONS_READ,
  PERMISSION_VACANCIES_READ
} from '../../constants'
import WithAjax from '../common/helpers/WithAjax'
import {fetchSkillVendorProductionsSuccess} from '../../actions/pages/skillvendor-page'
import {checkPermission} from '../common/functions/permissions'
import Table from '../../tables/reactable/DefaultTable'
import StatusBadge from '../common/helpers/StatusBadge'

class ProductionsGrid extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onFilter = this.onFilter.bind(this)
    this.state = {
      itemsPerPage: 10,
      openBtnLabel: 'View',
      search: '',
      filter: {
        Status: ''
      }
    }
    this.columns = [
      'OriginalTitle',
      'TitleForSearch',
      'Description',
      'SkillTypeLabel',
      'Status',
      'VacancyStatus'
    ]
    this.columnNames = [
      'Title',
      'TitleForSearch',
      'Description',
      'Speciality',
      'Status',
      'Vacancy status'
    ]
  }

  componentDidMount() {
    if (this.props.productions === null){
      this.fetchProductions();
    }
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  fetchProductions() {
    let url = 'skillVendors/' + this.props.skillVendorId + '/productions'

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        if(data[index].VacancyType === 'VoiceTest')
        {
          data[index].NavigationParam = 'voicetests/'+data[index].VacancyId;
        }
        else
        {
          data[index].NavigationParam = 'vacancies/'+data[index].VacancyId;
        }
      });

      this.props.fetchSkillVendorProductionsSuccess(data);
    });
  }

  onSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
    return false
  }

  onFilter(filter){
    this.setState({
      filter: filter
    })
  }

  render() {
    if (this.props.productions === null) {
      return (<div />)
    }

    let items = this.props.productions.map(item => {
      return Object.assign({}, item, {
        Status: (<StatusBadge status={item.Status.toLowerCase()} statusLabel={item.StatusLabel} />),
        VacancyStatus: (<StatusBadge status={item.VacancyStatus.toLowerCase()} statusLabel={item.VacancyStatusLabel} />),
        TitleForSearch: item.OriginalTitle,
        OriginalTitle: checkPermission(PERMISSION_PRODUCTIONS_READ)
          ? (<a href={'/productions/' + item.ProductionId + '/overview'}>{item.OriginalTitle}</a>)
          : (<span>{item.OriginalTitle}</span>)
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          hiddenColumns={['TitleForSearch']}
          searchable={[
            'Description',
            'TitleForSearch',
            'SkillTypeLabel'
          ]}
          search={this.state.search}
          onSearch={this.onSearch}
          filterable={[{
            column: 'Status',
            filters: [
              {
                value: 'matched',
                label: 'Matched'
              },
              {
                value: 'suggested',
                label: 'Suggested'
              },
              {
                value: 'applied',
                label: 'Applied'
              },
              {
                value: 'prehired',
                label: 'Pre Hired'
              },
              {
                value: 'hired',
                label: 'Hired'
              }
            ]
          }]}
          filter={this.state.filter}
          onFilter={this.onFilter}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={checkPermission(PERMISSION_VACANCIES_READ)}
          openBtnLabel={this.state.openBtnLabel}
          openBtnHref="/{NavigationParam}/candidates"
          sortable={[
            {
              column: 'OriginalTitle',
              sortFunction: function(a, b) {
                return a.props.children.localeCompare(b.props.children);
              }
            },
            'Description',
            'SkillTypeLabel',
            {
                column: 'Status',
                sortFunction: function(a, b){
                  return a.props.statusLabel.localeCompare(b.props.statusLabel);
                }
            },
            {
              column: 'VacancyStatus',
              sortFunction: function(a, b){
                return a.props.statusLabel.localeCompare(b.props.statusLabel);
              }
          }
          ]}
          defaultSort={{column: 'OriginalTitle', direction: 'asc'}}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorId: state.skillVendorPage.overview.Id,
  productions: state.skillVendorPage.productions
})
const mapDispatchToProps = dispatch => ({
  fetchSkillVendorProductionsSuccess(productions) { dispatch(fetchSkillVendorProductionsSuccess(productions)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(ProductionsGrid))
